import { t, Trans } from "@lingui/macro";
import { Box, Button } from "@mui/material";
import { AutoSelectTextField } from "@WahooFitness/redesignr";
import { useEffect, useState } from "react";

function RenameWorkoutProfileDrawer({
  profileNameRef,
  profileName,
  handleCancel,
  error,
  handleKeyPress,
  handleSave,
  checkValid,
}: {
  profileNameRef: React.Ref<HTMLInputElement>;
  profileName?: string;
  handleCancel: () => void;
  handleSave: () => void;
  checkValid: () => void;
  handleKeyPress: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  error: string | undefined;
}) {
  const [value, setValue] = useState(`${profileName ?? ""}`);

  useEffect(() => {
    setValue(`${profileName ?? ""}`);
  }, [profileName]);

  return (
    <Box display="flex" gap={2} p={3} flexDirection="column">
      <AutoSelectTextField
        inputRef={profileNameRef}
        fullWidth
        variant="outlined"
        label={t`Profile name`}
        defaultValue={value}
        onChange={checkValid}
        onKeyUp={handleKeyPress}
        error={!!error}
        helperText={error}
        inputProps={{ maxLength: 30 }}
        onContextMenu={(event) => {
          event.preventDefault();
        }}
      />
      <Box display="flex" flexDirection="row" gap={1.5} py={3}>
        <Button variant="outlined" size="large" fullWidth onClick={handleCancel}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="contained" size="large" fullWidth onClick={handleSave}>
          <Trans>Save</Trans>
        </Button>
      </Box>
    </Box>
  );
}

export default RenameWorkoutProfileDrawer;
